import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Banknote, History, Landmark, Menu, Wallet as WalletIcon } from "lucide-react";
import API from "../services/api";
import BottomNav from "../components/BottomNav";

function Wallet() {
  const navigate = useNavigate();
  const user = useMemo(() => JSON.parse(localStorage.getItem("user") || "null"), []);
  const [wallet, setWallet] = useState({ balance: 0, bonus: 0 });

  const fetchWallet = useCallback(async () => {
    if (!user?.id) return;
    try {
      const res = await API.get(`/wallet/${user.id}`);
      setWallet(res.data || { balance: 0, bonus: 0 });
    } catch {
      setWallet({ balance: 0, bonus: 0 });
    }
  }, [user]);

  useEffect(() => {
    if (!user?.id) { navigate("/login"); return; }
    fetchWallet();
  }, [fetchWallet, navigate, user]);

  const menuItems = [
    {
      label: "Add Fund",
      icon: <Banknote size={22} color="#fff" />,
      iconBg: "#e91e8c",
      border: "#e91e8c",
      onClick: () => navigate("/deposit"),
    },
    {
      label: "Withdraw Fund",
      icon: <WalletIcon size={22} color="#fff" />,
      iconBg: "#7c3aed",
      border: "#7c3aed",
      onClick: () => navigate("/withdraw"),
    },
    {
      label: "Add Bank Details",
      icon: <Landmark size={22} color="#fff" />,
      iconBg: "#16a34a",
      border: "#16a34a",
      onClick: () => navigate("/bank-accounts"),
    },
  ];

  return (
    <div style={page}>
      {/* Header */}
      <header style={header}>
        <button type="button" style={menuBtn} onClick={() => {}}>
          <Menu size={22} color="#fff" />
        </button>
        <span style={headerTitle}>Wallet</span>
        <div style={headerBal}>
          <span style={headerBalLabel}>Balance</span>
          <span style={headerBalAmt}>₹{Number(wallet.balance || 0).toFixed(2)}</span>
        </div>
      </header>

      {/* Menu items */}
      <div style={menuList}>
        {menuItems.map((item) => (
          <button key={item.label} type="button" style={{ ...menuCard, borderLeft: `4px solid ${item.border}` }} onClick={item.onClick}>
            <span style={{ ...iconCircle, background: item.iconBg }}>
              {item.icon}
            </span>
            <span style={menuLabel}>{item.label}</span>
            <span style={arrow}>›</span>
          </button>
        ))}
      </div>

      {/* Transaction History bar */}
      <div style={txnSection}>
        <div style={txnSectionTitle}>
          <History size={14} color="#4f46e5" />
          Transaction History
        </div>
        <div style={txnBar}>
          <button type="button" style={txnBarBtn} onClick={() => navigate("/account?tab=dw")}>
            <span style={{ ...txnBarIcon, background: "linear-gradient(135deg,#e91e8c,#c2185b)" }}>
              <Banknote size={16} color="#fff" />
            </span>
            <div style={txnBarInfo}>
              <div style={txnBarLabel}>Deposit</div>
              <div style={txnBarSub}>History</div>
            </div>
            <ArrowRight size={15} color="#c7d2fe" />
          </button>
          <div style={txnBarDivider} />
          <button type="button" style={txnBarBtn} onClick={() => navigate("/account?tab=dw")}>
            <span style={{ ...txnBarIcon, background: "linear-gradient(135deg,#7c3aed,#4f46e5)" }}>
              <WalletIcon size={16} color="#fff" />
            </span>
            <div style={txnBarInfo}>
              <div style={txnBarLabel}>Withdraw</div>
              <div style={txnBarSub}>History</div>
            </div>
            <ArrowRight size={15} color="#c7d2fe" />
          </button>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}

const page = { minHeight: "100vh", background: "#f1f5f9", paddingBottom: 80 };

const header = {
  background: "linear-gradient(135deg, #4f46e5 0%, #312e81 100%)",
  height: 58,
  display: "flex",
  alignItems: "center",
  padding: "0 16px",
  gap: 12,
};
const menuBtn = { border: 0, background: "transparent", display: "grid", placeItems: "center", padding: 4, cursor: "pointer" };
const headerTitle = { flex: 1, fontSize: 18, fontWeight: 800, color: "#fff" };
const headerBal = { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1 };
const headerBalLabel = { fontSize: 10, fontWeight: 600, color: "rgba(255,255,255,0.6)", letterSpacing: "0.04em" };
const headerBalAmt = { fontSize: 16, fontWeight: 900, color: "#fff" };

const menuList = { padding: "18px 14px 10px", display: "grid", gap: 12 };
const txnSection = { padding: "0 14px 20px" };
const txnSectionTitle = { display: "flex", alignItems: "center", gap: 7, fontSize: 13, fontWeight: 800, color: "#4f46e5", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 12 };
const txnBar = { background: "#fff", border: "1.5px solid #e0e7ff", borderRadius: 16, display: "flex", alignItems: "stretch", overflow: "hidden", boxShadow: "0 2px 10px rgba(79,70,229,0.07)" };
const txnBarBtn = { flex: 1, display: "flex", alignItems: "center", gap: 10, padding: "14px 14px", cursor: "pointer", background: "transparent", border: 0, textAlign: "left" };
const txnBarIcon = { width: 36, height: 36, borderRadius: "50%", display: "grid", placeItems: "center", flexShrink: 0 };
const txnBarInfo = { flex: 1 };
const txnBarLabel = { fontSize: 13, fontWeight: 800, color: "#1e293b" };
const txnBarSub = { fontSize: 11, color: "#94a3b8", marginTop: 1 };
const txnBarDivider = { width: 1, background: "#e0e7ff", flexShrink: 0, margin: "10px 0" };
const menuCard = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 14,
  padding: "16px 18px",
  display: "flex",
  alignItems: "center",
  gap: 16,
  cursor: "pointer",
  textAlign: "left",
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
};
const iconCircle = { width: 46, height: 46, borderRadius: "50%", display: "grid", placeItems: "center", flexShrink: 0 };
const menuLabel = { flex: 1, fontSize: 15, fontWeight: 700, color: "#1e293b" };
const arrow = { fontSize: 22, color: "#94a3b8", fontWeight: 300 };

export default Wallet;
